<app-header [label]="'Re-evaluation'"></app-header>

<!-- Tabs row -->
<div class="bg-white border-b border-gray-200 px-4 py-3">
  <app-toggle-tabs
    [tabs]="tabList"
    [defaultActive]="'All'"
    [params]="params"
    params_name="status">
  </app-toggle-tabs>
</div>

<app-ag-grid-list
  [list]="items"
  [colDefs]="re_evaluations_cols"
  [itemName]="page_name"
  [show_checkboxes]="is_admin_view"
  (fetch_new_list)="get_list($event)">
  <!-- Filters row — Student variant (Academic Year + Exam) -->
  <div toolbar *ngIf="is_student_view"
       class="flex bg-white gap-4 items-center justify-between p-4 border-b border-gray-300">
    <div class="flex items-center gap-3 flex-1">
      <app-select-input
        class="w-[180px] shrink-0"
        label="Academic Year"
        [options]="dds.dropdown_list?.academic_list"
        (valueChange)="on_student_academic_year_change($event)">
      </app-select-input>
      <app-select-input
        #exam_dropdown
        class="flex-1"
        label="Exam Name"
        [options]="student_exam_list"
        [patch_first_value]="true"
        (valueChange)="on_student_exam_change($event)">
      </app-select-input>
    </div>
    <div class="flex items-center gap-2 shrink-0">
      <app-search-input #student_search (fetch_new_list)="get_list($event)"></app-search-input>
      <button (click)="download()"
              class="w-10 h-10 flex items-center justify-center rounded-full border border-[#3F41D1] text-[#3F41D1] hover:bg-indigo-50 transition-all shrink-0">
        <i class="bx bx-download text-xl"></i>
      </button>
    </div>
  </div>

  <!-- Filters row — Admin variant (search + bulk actions) -->
  <div toolbar *ngIf="is_admin_view"
       class="flex bg-white gap-4 items-center justify-between p-4 border-b border-gray-300">
    <app-search-input #searchbar (fetch_new_list)="get_list($event)"></app-search-input>
    <div class="flex items-center gap-2 ml-auto">
      <span class="text-sm text-gray-500" *ngIf="selected_request_ids?.length">
        {{ selected_request_ids.length }} selected
      </span>
      <app-button
        label="Auto-Assign"
        type="secondary"
        [disabled]="!selected_request_ids?.length || is_assigning"
        (button_clicked)="auto_assign_selected()">
      </app-button>
      <app-button
        label="Assign"
        type="primary"
        [disabled]="!selected_request_ids?.length || is_assigning"
        (button_clicked)="assign_selected()">
      </app-button>
    </div>
  </div>
</app-ag-grid-list>

<!--
  Per-row Evaluator + HE dropdowns are part of the admin queue (Figma image-5).
  The TS layer (`picks_by_request`) is already wired so once the grid wrapper
  exposes a row-selection event (today it only emits `bulkDelete`), bind:
      on_evaluator_change(row.id, $event)
      on_head_evaluator_change(row.id, $event)
  Until then `selected_request_ids` is auto-populated from all visible rows so
  the Auto-Assign / Assign header buttons operate on the current page.
-->
